import styles from './Kbd.module.scss'

export const Kbd = ({ children }: { children: React.ReactNode }) => <kbd className={styles.kbd}>{children}</kbd>
